import { api } from "@/utils/api";

export default class NrwRepository {
  async getNrwReport(locationId: any): Promise<any> {
    const response = await api.get(`nrw/historical/${locationId}`);
    return response.data;
  }

  async getNRWDates(
    locationId: string | number,
    startDate: string,
    endDate: string
  ): Promise<any> {
    const url = `nrw/${locationId}/custom?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  
    const response = await api.get(url);
  
    return response.data;
  }
}

